import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TelegramView from "../components/TelegramView";
import { Routes, Route, Navigate, useOutletContext } from "react-router-dom";
import Game from "../components/Game";
import Dashbord from "../components/Dashbord";
import Dialog from "../components/Dialog";
import SideMenu from "../components/SideMenu";
import Rules from "../components/Rules";
import Profile from "../components/Profile";
import Instruction from "../components/Instruction";
import Price from "../components/Price";
import KnowledgeBasePage from "./KnowledgeBasePage";
import TeamMotivationPage from "./TeamMotivationPage";
import { getRules, getInfo } from "../redux/asyncThunk/serviceActions";
import { getProfile } from "../redux/asyncThunk/userActions";
import { userSlice } from "../redux/user/userSlice";
import useMediaQuery from "../hooks/useMediaQuery";
import AppNotifier from "../components/AppNotifier";
import "./app-workspace.css";

const { clearMessages } = userSlice;

export default function PersonalPage() {
  const dispatch = useDispatch();
  const isMobileNav = useMediaQuery("(max-width: 900px)");
  const outletContext = useOutletContext() ?? {};
  const sidebarOpen = Boolean(outletContext.mobileSidebarOpen);
  const closeSidebar = outletContext.closeMobileSidebar ?? (() => {});

  const showDialog = useSelector((state) => state.user.showDialog);
  const rules = useSelector((state) => state.serviceData.rules);
  const info = useSelector((state) => state.serviceData.info);
  const userId = useSelector((state) => state.user.data?.user?.id);

  useEffect(() => {
    if (!rules.lenght || !info.lenght) {
      dispatch(getRules());
      dispatch(getInfo());
    }
    dispatch(clearMessages());
  }, [dispatch, info.lenght, rules.lenght, userId]);

  useEffect(() => {
    if (userId) {
      dispatch(getProfile({ id: userId }));
    }
  }, [dispatch, userId]);

  return (
    <div
      className={`app-workspace${
        sidebarOpen ? " app-workspace--sidebar-open" : ""
      }`}
    >
      {isMobileNav && sidebarOpen ? (
        <button
          type="button"
          className="app-workspace__backdrop"
          aria-label="Закрыть меню"
          onClick={closeSidebar}
        />
      ) : null}

      <SideMenu
        mobileOpen={isMobileNav && sidebarOpen}
        onNavigate={closeSidebar}
      />

      <div className="app-workspace__main">
        <Routes>
          <Route path="/" element={<Dashbord />} />
          <Route path="/motivation" element={<Navigate to="/main/rating" replace />} />
          <Route
            path="/rating"
            element={
              <div className="app-main">
                <TeamMotivationPage />
              </div>
            }
          />
          <Route
            path="/knowledge-base"
            element={
              <div className="app-main app-main--knowledge-base">
                <KnowledgeBasePage />
              </div>
            }
          />
          <Route
            path="/:id"
            element={
              <div className="app-main">
                <Game />
              </div>
            }
          />
          <Route
            path="/profile"
            element={
              <div className="app-main">
                <Profile />
              </div>
            }
          />
          <Route
            path="/rules"
            element={
              <div className="app-main">
                <Rules />
              </div>
            }
          />
          <Route
            path="/instruction"
            element={
              <div className="app-main">
                <Instruction />
              </div>
            }
          />
          <Route
            path="/price"
            element={
              <div className="app-main">
                <Price />
              </div>
            }
          />
        </Routes>
      </div>

      <TelegramView />

      {showDialog.isOpen ? <Dialog /> : null}

      <AppNotifier />
    </div>
  );
}
